class ComboCheckboxes extends HTMLElement {
  connectedCallback() {
    this.select = this.querySelector('[data-combo-select]');
    this.checkboxA = this.querySelector('[data-combo-feature="a"]');
    this.checkboxB = this.querySelector('[data-combo-feature="b"]');
    if (!this.select || !this.checkboxA || !this.checkboxB) return;

    this.featureA = this.dataset.featureA;
    this.featureB = this.dataset.featureB;
    this.noneValue = this.dataset.noneValue;
    this.combinedValue = this.dataset.combinedValue;

    this.syncCheckboxesFromSelect();
    this.updateDisabledState();
    this.addEventListener('change', this.onChange);
  }

  onChange = (event) => {
    if (event.target !== this.checkboxA && event.target !== this.checkboxB) return;

    event.stopPropagation();

    const targetValue = this.computeTargetValue();
    const matchingOption = Array.from(this.select.options).find((o) => o.value === targetValue);
    if (!matchingOption) {
      event.target.checked = !event.target.checked;
      return;
    }

    this.select.value = targetValue;
    this.select.dispatchEvent(new Event('change', { bubbles: true }));
  };

  isStateAvailable(a, b) {
    if (a && b) return this.dataset.availableCombined === '1';
    if (a) return this.dataset.availableA === '1';
    if (b) return this.dataset.availableB === '1';
    return this.dataset.availableNone === '1';
  }

  updateDisabledState() {
    const a = this.checkboxA.checked;
    const b = this.checkboxB.checked;
    this.checkboxA.disabled = !this.isStateAvailable(!a, b);
    this.checkboxB.disabled = !this.isStateAvailable(a, !b);
  }

  computeTargetValue() {
    const a = this.checkboxA.checked;
    const b = this.checkboxB.checked;
    if (a && b) return this.combinedValue;
    if (a) return this.featureA;
    if (b) return this.featureB;
    return this.noneValue;
  }

  syncCheckboxesFromSelect() {
    const value = this.select.value;
    this.checkboxA.checked = value === this.combinedValue || value === this.featureA;
    this.checkboxB.checked = value === this.combinedValue || value === this.featureB;
  }
}

if (!customElements.get('combo-checkboxes')) {
  customElements.define('combo-checkboxes', ComboCheckboxes);
}